import React from 'react';
import ReactDOM from 'react-dom';
import 'fpsmeter';

type FpsMeterProps = {
  refFpsMeter: (fpsMeter: FPSMeter | null) => void;
};

export class FpsMeter extends React.Component<FpsMeterProps, {}> {
  private meter: FPSMeter | undefined;
  private divFpsMeterCounter: HTMLDivElement | undefined;

  componentDidMount() {
    const divNode = ReactDOM.findDOMNode(
      this.divFpsMeterCounter,
    ) as HTMLDivElement;

    this.meter = new FPSMeter(divNode, {
      theme: 'myTheme',
      decimals: 1,
      top: '3px',
    });

    this.props.refFpsMeter(this.meter);
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    this.meter.destroy();
    this.props.refFpsMeter(null);
  }

  render() {
    return <div ref={ref => (this.divFpsMeterCounter = ref)} />;
  }
}

const fpsMeterThemes = (FPSMeter as any).theme;

const lightTheme = fpsMeterThemes.light;

(FPSMeter as any).theme.myTheme = {
  ...lightTheme,
  container: {
    ...lightTheme.container,
    boxShadow: 'none',
    textShadow: 'none',
    background: 'transparent',
  },
  count: {
    ...lightTheme.count,
    padding: '5px 3px',
  },
};
